module.exports = __webpack_public_path__ + "img/Colombia.ad8fedd4.gif";